import axios from "axios"; //引入axios依赖
import Message from "@/components/commonMessage/message.js";
import GlobalStore from "../store/global";

axios.defaults.timeout = 5000;
axios.defaults.baseURL = process.env.VUE_APP_BASEURL;

//http request 封装请求头拦截器
axios.interceptors.request.use(
  (config) => {
    config.data = JSON.stringify(config.data);
    config.headers = {
      "Content-Type": "application/json",
    };
    if (localStorage.token) {
      config.headers.token = localStorage.token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(err);
  }
);

//http response 封装返回拦截器
axios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error.response.status) {
      switch (error.response.status) {
        // 404请求不存在
        case 404:
          Message({
            message: "网络请求不存在",
            type: "danger",
            duration: "3000",
          });
          break;
        case 500:
          Message({
            message: error.response.data.message || "请求失败，服务器异常",
            type: "danger",
            duration: "3000",
          });
          break;
        // 其他错误，直接抛出错误提示
        default:
          Message({
            message: error.response.data.message,
            type: "danger",
            duration: "3000",
          });
      }
    }
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export const get = (url, params = {}) => {
  GlobalStore.loading = true;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {
        GlobalStore.loading = false;
      });
  });
};

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise
 */

export const post = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export const patch = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export const deleteFun = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
};

/**
 * 封装导出请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export const exportFun = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: url,
      data: data,
      responseType: "blob",
    }).then(
      (response) => {
        resolve(response.data);
        let blob = new Blob([response.data], { type: "application/excel" });
        let fileName = response.data.fileName;
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
      },
      (err) => {
        reject(err);
      }
    );
  });
};
